// Client-side pricing engine (mirrors backend for instant UI feedback)
export const DEFAULT_RATES = {
  graphic_design:    { min:  40, avg:  85, max: 170 },
  web_dev:           { min:  75, avg: 150, max: 300 },
  app_dev:           { min: 110, avg: 220, max: 420 },
  content_writing:   { min:  25, avg:  55, max: 120 },
  digital_marketing: { min:  55, avg: 120, max: 240 },
  ui_ux_design:      { min:  75, avg: 160, max: 320 },
  video_editing:     { min:  55, avg: 130, max: 260 },
  seo_consulting:    { min:  65, avg: 140, max: 260 },
};

export const EXPERIENCE_MULT = { beginner: 0.75, intermediate: 1.0, expert: 1.45 };
export const COMPLEXITY_MULT = { simple: 0.85, medium: 1.0, complex: 1.35 };
export const UNIT_HOURS = { hour: 1, day: 8, project: 20 };
export const RUSH_SURCHARGE = 0.30;
export const REVISION_FEE_RATIO = 0.05;

export function computePricing({
  service, experience, complexity, unit, quantity, revisions, rush, customRates,
}) {
  const rates = (customRates && customRates[service]) || DEFAULT_RATES[service];
  if (!rates) return null;

  const expM = EXPERIENCE_MULT[experience];
  const cxM = COMPLEXITY_MULT[complexity];
  const hours = Number(quantity || 0) * UNIT_HOURS[unit];

  const calc = (hourly) => {
    const subtotal = hourly * hours * expM * cxM;
    const rushFee = rush ? subtotal * RUSH_SURCHARGE : 0;
    const extraRev = Math.max(0, (revisions || 0) - 2);
    const revFee = subtotal * REVISION_FEE_RATIO * extraRev;
    return subtotal + rushFee + revFee;
  };

  const subtotal = rates.avg * hours * expM * cxM;
  const rushFee = rush ? subtotal * RUSH_SURCHARGE : 0;
  const extraRev = Math.max(0, (revisions || 0) - 2);
  const revFee = subtotal * REVISION_FEE_RATIO * extraRev;

  return {
    hours,
    hourlyAvg: rates.avg,
    subtotal,
    rushFee,
    revFee,
    extraRev,
    expM,
    cxM,
    minPrice: calc(rates.min),
    avgPrice: calc(rates.avg),
    maxPrice: calc(rates.max),
  };
}

export const fmt = (n) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(Math.round(n || 0));
